<script>
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import LayoutPositionOptions from "%/dynamic-component-editor/bundles/layout-position-options";
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";

export default {
  name: "VerticalContainerWrapper",
  extends: Container,
  elementPanelSettings: {
    alias: "Vertical Container",
    displayName: "Container",
  },
  optionBundles: [
    PositioningOptions,
    new LayoutPositionOptions({
      "default.static-layout-direction": "vertical",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
};
</script>
